import { Link, useNavigate } from 'react-router-dom';
import { ReactComponent as BellIcon } from '../../../icons/bell.svg';
import { useUnreadMessageCount } from '../hooks/useUnreadMessageCount';
import { usePushNotification } from '../../chat/hooks/usePushNotification';

interface NotificationBadgeProps {
  artistId?: string;
  className?: string;
  onClick?: () => void;
}

export default function NotificationBadge({
  artistId,
  className = '',
  onClick
}: NotificationBadgeProps) {
  const navigate = useNavigate();

  const unreadMessageCount = useUnreadMessageCount();
  usePushNotification();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else if (artistId) {
      navigate(`/artists/${artistId}/notifications`);
    }
  };

  return (
    <Link to="/notifications" className={`relative ${className}`}>
      <button
        type="button"
        className="bg-secondary-light dark:bg-secondary-dark rounded-full p-[7px] flex items-center justify-center"
        onClick={handleClick}
      >
        <BellIcon className="fill-primary-light dark:fill-primary-dark w-[19px] h-[19px]" />
        {unreadMessageCount > 0 && (
          <div className="absolute -right-1 -top-1 w-4 h-4 rounded-full text-[10px] text-white bg-[#FF2E37] flex items-center justify-center">
            {unreadMessageCount}
          </div>
        )}
      </button>
    </Link>
  );
}
